// some locale letters are detected by regexp as non-word characters
export const toPascalCase = (string) => {
    return string.replace(/(\w)(.*)/g, (g0, g1, g2) => {
        return g1.toLocaleUpperCase() + g2.toLocaleLowerCase();
    });
};
